// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import EmailUsForm from "@mcmc/App/Components/EmailUsForm/EmailUsForm";
import PardotForm from "@mcmc/App/Components/PardotForm/PardotForm";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    formUrl?: string;
    onSuccessFormAction?: () => void;
}

const mapStateToProps = (state: ApplicationState) => {
    const customSettings = getSettingsCollection(state).customSettings;
    return {
        pardotIntegrationType: customSettings.pardotIntegrationType?.toLowerCase(),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ContactUsFormStyles {}

export const contactUsFormStyles: ContactUsFormStyles = {};

const styles = contactUsFormStyles;

enum PardotIntegrationType {
    Pardot = "pardot",
    Offline = "offline",
    None = "none",
}

const ContactUsForm = ({
    formUrl,
    pardotIntegrationType,
}: Props) => {
    return (
        <>
            {formUrl && pardotIntegrationType === PardotIntegrationType.Pardot && (
                <PardotForm formUrl={formUrl} />
            )}
            {pardotIntegrationType === PardotIntegrationType.Offline &&
                <EmailUsForm />
            }
        </>
    );
};

export default connect(mapStateToProps)(ContactUsForm);
